import { memo } from "react";

import { Flex } from "@/components/layout/flexbox";

import { DirectMessage } from "./DirectMessage";
import { MeetingChat } from "./MeetingChat";
import { ReviewChat } from "./ReviewChat";

interface ChatChannelProps {
  customerId?: string;
  channelId: string;
  backLinkTo?: string;
}

function ChatChannelWrapper({
  customerId,
  channelId,
  backLinkTo,
}: ChatChannelProps) {
  const [objectType, objectId] = channelId.split("_");

  const isDirectMessage = objectType && objectType === "DM";
  const isMeetingChat = objectType && objectType === "Meeting";
  const isReviewChat = objectType && objectType === "Review";

  if (isDirectMessage) {
    return (
      <DirectMessage
        assignmentId={objectId}
        backLinkTo={backLinkTo}
        canChat={true}
      />
    );
  }

  if (isMeetingChat && customerId) {
    return (
      <MeetingChat
        meetingId={objectId}
        customerId={customerId}
        backLinkTo={backLinkTo}
        canChat={true}
      />
    );
  }

  if (isReviewChat && customerId) {
    return (
      <ReviewChat
        reviewId={objectId}
        customerId={customerId}
        backLinkTo={backLinkTo}
        canChat={true}
      />
    );
  }

  return (
    <Flex p={4} flexDirection="column">
      Please choose a conversation from the left
    </Flex>
  );
}

export const ChatChannel = memo(ChatChannelWrapper);
